import React, { createContext, useState, useContext } from 'react';
import { getFromAPI } from '../../../Utils/utils';


// Create Context
export const BranchAdminContext = createContext();

// Custom hook to use the CustomerContext
export const useBranchAdmin = () => useContext(BranchAdminContext);

// Create a Context Provider component
export const BranchAdminProvider = ({ children }) => {
    const [getBranchAdmin, setBranchAdminData] = useState([]);

    const fetchBranchAdminData = async () => {
        try {
            const currentResponse = await getFromAPI("FtsStaff/");
            let currentList = Array.isArray(currentResponse) ? currentResponse : [];
            currentList = currentList.filter(s => s.isdeleted !== 1);
            let exList = [];
            try {
                const exResponse = await getFromAPI("FtsStaff/", undefined, { isdeleted: 1 });
                exList = Array.isArray(exResponse) ? exResponse : [];
            } catch (_) {}
            setBranchAdminData([...currentList, ...exList]);
        } catch (error) {
            console.error('Error fetching Branch Admin data:', error);
            setBranchAdminData([]);
        }
    };

    return (
        <BranchAdminContext.Provider value={{ getBranchAdmin, fetchBranchAdminData }}>
            {children}
        </BranchAdminContext.Provider>
    );
};
